import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";
import { getCustomerAddressNew } from "../../reduxApi/website/CustomerAddressApi";

export const addCustomerAddress = createAsyncThunk(
  "customer/address/create",
  async (addressData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${baseUrl}delivery-address/api/v1/create`,
        addressData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Return the response data WITHOUT dispatching getCustomerAddressNew here
      // Let the component handle the refresh manually
      return response.data;

    } catch (error) {
      if (error.response) {
        return rejectWithValue({
          message: error.response.data?.message || "Failed to add address",
          status: error.response.status,
          data: error.response.data
        });
      }

      return rejectWithValue({
        message: error.message || "Network error",
        status: 500,
      });
    }
  }
);

const CustomerAddAddressSlice = createSlice({
  name: "CustomerAddAddress",
  initialState: {
    status: "idle",
    error: null,
  },
  reducers: {
    resetAddAddressState: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomerAddress.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCustomerAddress.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addCustomerAddress.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetAddAddressState } = CustomerAddAddressSlice.actions;
export default CustomerAddAddressSlice.reducer;
// // import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// // import axios from "axios";


// // Async thunk to add a customer address
// import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import { baseUrl } from "../../../../boot";
// import { getCustomerAddressNew } from "../../reduxApi/website/CustomerAddressApi";
// export const addCustomerAddress = createAsyncThunk(
//   "customer/address/create",
//   async (addressData, { dispatch, rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         `${baseUrl}delivery-address/api/v1/create`,
//         addressData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // refresh address list after success
//       dispatch(getCustomerAddressNew());

//       return response.data;

//     } catch (error) {
//       if (error.response) {
//         return rejectWithValue({
//           message: error.response.data?.message || "Failed to add address",
//           status: error.response.status,
//           data: error.response.data
//         });
//       }

//       return rejectWithValue({
//         message: error.message || "Network error",
//         status: 500,
//       });
//     }
//   }
// );


// const CustomerAddAddressSlice = createSlice({
//   name: "CustomerAddAddress",
//   initialState: {
//     status: "idle",
//     error: null,
//   },
//   reducers: {
//     resetAddAddressState: (state) => {
//       state.status = "idle";
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(addCustomerAddress.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(addCustomerAddress.fulfilled, (state) => {
//         state.status = "succeeded";
//       })
//       .addCase(addCustomerAddress.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       });
//   },
// });

// export const { resetAddAddressState } = CustomerAddAddressSlice.actions;
// export default CustomerAddAddressSlice.reducer;

